export const CHECKER_SUBMISSION_REQUEST = 'CHECKER_SUBMISSION_REQUEST';
export const CHECKER_SUBMISSION_SUCCESS = 'CHECKER_SUBMISSION_SUCCESS';
export const CHECKER_SUBMISSION_FAIL = 'CHECKER_SUBMISSION_FAIL';
